export default __webpack_public_path__ + "static/media/dotnet_logo.5fee339a.png";